import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#C96B4B] text-white hover:bg-[#B55A3A] focus:ring-[#C96B4B] shadow-md',
    secondary: 'bg-[#1A5F5A] text-white hover:bg-[#144A46] focus:ring-[#1A5F5A] shadow-md',
    outline: 'border-2 border-[#1A5F5A] text-[#1A5F5A] hover:bg-[#E8F2F1] focus:ring-[#1A5F5A]',
    ghost: 'text-[#1A5F5A] hover:bg-[#E8F2F1] hover:text-[#144A46]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-137">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-138" />}
      {children}
    </motion.button>;
}